import { render, staticRenderFns } from "./ListPPage.vue?vue&type=template&id=5b040fc6&"
import script from "./ListPPage.vue?vue&type=script&lang=js&"
export * from "./ListPPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports